// Building a map to fetch the sample product of a fabric variant product
window.evSampleResolver = (() => {

  const variantCache = {};

  async function resolveSampleVariantId(baseSku, fabricHandle) {
    if (!baseSku || !fabricHandle) return null;

    // check cache first
    if (variantCache[baseSku]) {
      return variantCache[baseSku];
    }

    const sampleSku = `SFS${baseSku}`;
    const sampleHandle = `sfs-${fabricHandle}`;

    try {
      const res = await fetch(`/products/${sampleHandle}.js`);

      if (!res.ok) {
        console.warn(`[SampleResolver] Sample product not found: ${sampleHandle}`);
        return null;
      }

      const product = await res.json();

      const variant = product.variants.find(v => v.sku === sampleSku);

      if (!variant) {
        console.warn(`[SampleResolver] Sample variant not found for SKU: ${sampleSku}`);
        return null;
      }

      variantCache[baseSku] = variant.id;

      return variant.id;

    } catch (err) {
      console.error('[SampleResolver] Failed resolving sample', err);
      return null;
    }
  }

  return {
    resolveSampleVariantId
  };

})();

// PDP sample button handler
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll("[data-ev-sample-button]");
  if (!buttons.length) return;

  const originalLabels = new WeakMap();
  buttons.forEach((btn) => {
    originalLabels.set(btn, btn.textContent.trim() || "Order Sample");
  });

  function getCurrentBaseSku() {
    const skuEl = document.querySelector("[data-ev-variant-sku]");
    return skuEl ? skuEl.textContent.trim() : null;
  }

  function getCurrentFabricHandle() {
    const parts = window.location.pathname.split("/products/");
    return parts[1] ? parts[1].split("?")[0] : null;
  }

  function setButtonsState(state) {
    buttons.forEach((btn) => {
      const originalLabel = originalLabels.get(btn) || "Order Sample";

      if (state === "added") {
        btn.textContent = "Sample Added";
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        return;
      }

      if (state === "loading") {
        btn.textContent = "Adding...";
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        return;
      }

      btn.textContent = originalLabel;
      btn.disabled = false;
      btn.setAttribute("aria-disabled", "false");
    });
  }

  async function getCart() {
    const res = await fetch("/cart.js");
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  }

  function cartContainsVariant(cart, variantId) {
    return cart.items.some((item) => Number(item.id) === Number(variantId));
  }

  async function syncSampleButtonsFromCart() {
    const baseSku = getCurrentBaseSku();
    const fabricHandle = getCurrentFabricHandle();

    if (!baseSku || !fabricHandle) {
      setButtonsState("idle");
      return;
    }

    const variantId = await evSampleResolver.resolveSampleVariantId(baseSku, fabricHandle);

    if (!variantId) {
      setButtonsState("idle");
      return;
    }

    const cart = await getCart();

    if (cartContainsVariant(cart, variantId)) {
      setButtonsState("added");
    } else {
      setButtonsState("idle");
    }
  }

  async function addCurrentSampleToCart() {
    const baseSku = getCurrentBaseSku();
    const fabricHandle = getCurrentFabricHandle();

    if (!baseSku || !fabricHandle) {
      console.warn("[SampleAdd] Missing SKU or handle");
      return;
    }

    setButtonsState("loading");

    try {
      const variantId = await evSampleResolver.resolveSampleVariantId(baseSku, fabricHandle);

      if (!variantId) {
        console.warn("[SampleAdd] Sample variant not found");
        setButtonsState("idle");
        return;
      }

      const cart = await getCart();

      if (cartContainsVariant(cart, variantId)) {
        setButtonsState("added");
        return;
      }

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      if (!res.ok) {
        throw new Error("Cart add failed");
      }

      await updateCartBubble();
      setButtonsState("added");
    } catch (err) {
      console.error("[SampleAdd] Add failed", err);
      setButtonsState("idle");
    }
  }

  buttons.forEach((btn) => {
    btn.addEventListener("click", async (event) => {
      event.preventDefault();
      await addCurrentSampleToCart();
    });
  });

  syncSampleButtonsFromCart().catch((err) => {
    console.warn("[SampleAdd] Initial sync failed", err);
  });

  const skuEl = document.querySelector("[data-ev-variant-sku]");
  if (skuEl) {
    const observer = new MutationObserver(() => {
      syncSampleButtonsFromCart().catch((err) => {
        console.warn("[SampleAdd] SKU sync failed", err);
      });
    });

    observer.observe(skuEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
});

// Variant product cards sample button handler
document.addEventListener("DOMContentLoaded", () => {
  const cardButtons = document.querySelectorAll("[data-ev-sample-card-button]");
  if (!cardButtons.length) return;

  const buttonLabels = new WeakMap();

  cardButtons.forEach((btn) => {
    buttonLabels.set(btn, btn.textContent.trim() || "+ ADD SAMPLE");
  });

  function findSampleCardButton(target) {
    if (!(target instanceof Element)) return null;
    return target.closest("[data-ev-sample-card-button]");
  }

  async function handleSampleCardButton(btn) {
    const baseSku = (btn.dataset.baseSku || "").trim();
    const fabricHandle = (btn.dataset.fabricHandle || "").trim();

    if (!baseSku || !fabricHandle) {
      console.warn("[SampleAdd] Card button missing SKU or handle");
      return;
    }

    const originalLabel = buttonLabels.get(btn) || "+ ADD SAMPLE";

    try {
      btn.disabled = true;
      btn.setAttribute("aria-disabled", "true");
      btn.textContent = "ADDING...";

      const variantId = await evSampleResolver.resolveSampleVariantId(baseSku, fabricHandle);

      if (!variantId) {
        btn.textContent = originalLabel;
        btn.disabled = false;
        btn.setAttribute("aria-disabled", "false");
        btn.closest(".ev-collection-sample-slot")?.setAttribute("hidden", "hidden");
        return;
      }

      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      const alreadyInCart = cart.items.some((item) => Number(item.id) === Number(variantId));

      if (alreadyInCart) {
        btn.textContent = "SAMPLE ADDED";
        return;
      }

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      if (!addRes.ok) {
        throw new Error("Card sample add failed");
      }

      await updateCartBubble();
      btn.textContent = "SAMPLE ADDED";
    } catch (err) {
      console.error("[SampleAdd] Card sample add failed", err);
      btn.textContent = originalLabel;
      btn.disabled = false;
      btn.setAttribute("aria-disabled", "false");
    }
  }

  document.addEventListener(
    "pointerdown",
    (event) => {
      const btn = findSampleCardButton(event.target);
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    { capture: true }
  );

  document.addEventListener(
    "click",
    (event) => {
      const btn = findSampleCardButton(event.target);
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleSampleCardButton(btn);
    },
    { capture: true }
  );
});


















// Update the header cart icon bubble count
async function updateCartBubble() {

  try {

    const res = await fetch("/cart.js");
    const cart = await res.json();

    const cartIcon = document.getElementById("cart-icon-bubble");
    if (!cartIcon) return;

    const bubble = cartIcon.querySelector(".cart-count-bubble");

    if (cart.item_count > 0) {

      cartIcon.classList.remove("hide-cart-if-empty");

      if (!bubble) {

        const newBubble = document.createElement("div");
        newBubble.className = "cart-count-bubble";
        newBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;

        cartIcon.appendChild(newBubble);

      } else {

        bubble.querySelector("span").textContent = cart.item_count;

      }

    }

  } catch (err) {

    console.warn("[SampleAdd] Failed updating cart bubble");

  }

}
